document.addEventListener("DOMContentLoaded", function () {
  const performanceData = {
    gaming: {
      title: "Gaming Performance",
      description: "Average FPS in AAA games at Ultra settings, 4K resolution",
      stats: [
        { name: "Stratos-18", value: 240, max: 240 },
        { name: "Competitor A", value: 180, max: 240 },
        { name: "Competitor B", value: 140, max: 240 }
      ],
      highlight: "Up to 33% faster than the competition"
    },
    content: {
      title: "Content Creation",
      description: "4K Rendering Time (lower is better)",
      stats: [
        { name: "Stratos-18", value: 12, max: 12 },
        { name: "Competitor A", value: 16, max: 12 },
        { name: "Competitor B", value: 18, max: 12 }
      ],
      highlight: "Renders up to 50% faster"
    }, 
    pro: {
      title: "Professional Workloads",
      description: "Blender Rendering Time (lower is better)",
      stats: [
        { name: "Stratos-18", value: 8, max: 8 },
        { name: "Competitor A", value: 12, max: 8 },
        { name: "Competitor B", value: 15, max: 8 }
      ],
      highlight: "Up to 50% faster in professional workloads"
    }
  };

  function updatePerformance(category) {
    const data = performanceData[category];
    if (!data) return;

    document.getElementById("performance-title").textContent = data.title;
    document.getElementById("performance-description").textContent = data.description;
    document.getElementById("performance-highlight").textContent = data.highlight;

    const performanceMetricsContainer = document.getElementById("performance-metrics");
    if (performanceMetricsContainer) {
      performanceMetricsContainer.innerHTML = "";

      data.stats.forEach((stat) => {
        const metricRow = document.createElement("div");
        metricRow.classList.add("metric-row");

        const name = document.createElement("span");
        name.classList.add("metric-label");
        name.textContent = stat.name;

        const barContainer = document.createElement("div");
        barContainer.classList.add("perf-bar-container");

        const bar = document.createElement("div");
        bar.classList.add("perf-bar");
        bar.style.width = "0%"; // Start at 0 for animation

        const value = document.createElement("span");
        value.classList.add("metric-value");
        value.textContent = stat.value + (category === "content" ? "s" : " FPS");

        barContainer.appendChild(bar);
        metricRow.appendChild(name);
        metricRow.appendChild(barContainer);
        metricRow.appendChild(value);

        performanceMetricsContainer.appendChild(metricRow);

        // Animate after a delay to allow rendering
        setTimeout(() => {
          bar.style.width = (stat.value / stat.max) * 100 + "%";
          console.log("Animating:", stat.name, "to width:", (stat.value / stat.max) * 100 + "%");
        }, 100);
      });
    }

    document.querySelectorAll(".perf-btn").forEach((btn) => {
      btn.classList.remove("active");
    });

    document.querySelector(`[data-category="${category}"]`).classList.add("active");
  }

  document.querySelectorAll(".perf-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const category = btn.getAttribute("data-category");
      console.log("Button clicked:", category);
      updatePerformance(category);
    });
  });

  setTimeout(() => {
    updatePerformance("gaming");
  }, 500);
});
